import { styled } from "@mui/material/styles";
import * as React from "react";

const StageLineStepContainer = styled("div")(({ theme }) => ({
  position: "relative",
  borderColor: "unset",
}));

const StageLineContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  borderTop: "1px solid",
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  paddingBottom: 16,
  position: "relative",
  "& *": {
    borderColor: "#333",
  },
}));

const StageLinePosition = styled("div")(({ theme }) => ({
  position: "relative",
  display: "block",
  width: 1,
  height: 6,
  top: 0,
  border: "0.5px solid",
  borderColor: "inherit",
  // backgroundColor: "inherit",
}));

const StageLineText = styled("div")<{
  align?: "left" | "center" | "right";
  active?: "true" | "false";
}>(({ theme, align = "left", active = "false" }) =>
  Object.assign({
    top: theme.spacing(2),
    textAlign: align,
    position: "absolute",
    whiteSpace: "nowrap",
    right: align === "right" ? 0 : "unset",
    transform: align === "center" ? "translateX(-50%)" : "unset",
    left: align === "center" ? 2 : "unset",
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.body2.fontSize,
    color: "inherit",
    // color: active ? "inheri" : theme.palette.text.secondary,
    fontWeight:
      active === "true"
        ? theme.typography.fontWeightSemiBold
        : theme.typography.fontWeightMedium,
  })
);

const StageLineIcon = styled("div")<{
  align?: "left" | "center" | "right";
}>(({ theme, align = "left" }) =>
  Object.assign({
    borderTopColor: "inherit",
    borderRightColor: "transparent",
    borderBottomColor: "transparent",
    borderLeftColor: "transparent",
    borderStyle: "solid",
    borderWidth: "12px 7px 0",
    position: "relative",
    top: -6,
    left: -6,
  })
);

type Props = {
  steps: number;
  stepLabels: string[];
  activeStep: number;
};

export type StageLineHandle = {};

export default function StageLine(props: Props): React.ReactElement {
  const { steps, stepLabels, activeStep } = props;

  const stepsDOM = React.useMemo(() => {
    const arr = [];
    for (let i = 0; i < steps; i++) {
      let textAlign = "left";
      if (i === steps / 2) {
        textAlign = "center";
      }
      if (i > steps / 2) {
        textAlign = "right";
      }
      arr.push(
        <StageLineStepContainer key={`stage-line-step-${i}`}>
          <StageLinePosition />
          {i === activeStep && <StageLineIcon />}
          <StageLineText
            align={i === 0 ? "left" : i === steps - 1 ? "right" : "center"}
          >
            {stepLabels[i] || ""}
          </StageLineText>
        </StageLineStepContainer>
      );
    }
    return arr;
  }, [steps, stepLabels, activeStep]);

  return <StageLineContainer>{stepsDOM}</StageLineContainer>;
}
